import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useUnit } from "effector-react";
import { $goalsStore, fetchSingleGoalRequested } from "../store";
import { MatchingCalls } from "../components/MatchingCalls";
import Loader from "@/core/components/loader/Loader";

export const MatchingCallsPage: React.FC = () => {
  const { goalId } = useParams<{ goalId: string }>();
  const navigate = useNavigate();

  const { singleGoal, loading, error } = useUnit($goalsStore);

  const fetchGoal = useUnit(fetchSingleGoalRequested);

  useEffect(() => {
    if (goalId) {
      fetchGoal({ goalId });
    }
  }, [goalId, fetchGoal]);

  useEffect(() => {
    if (error && !loading && goalId) {
      navigate("/goals", { replace: true });
    }
  }, [error, loading, goalId, navigate]);

  const handleBack = () => {
    navigate("/goals");
  };

  if (loading || !singleGoal) {
    return <Loader message="Loading goal details..." overlay />;
  }

  if (!goalId) {
    navigate("/goals", { replace: true });
    return null;
  }

  return <MatchingCalls goal={singleGoal} onBack={handleBack} />;
};
